import React from "react";
import {useForm} from "react-hook-form";
import {useDispatch} from "react-redux";
import {Button, createStyles, Grid, makeStyles, Paper, Typography} from "@material-ui/core";
import TextFieldController from "../../../components/TextFieldController";
import {postOperador} from "../../../actions/stationActions";

const useStyles = makeStyles((theme) =>
    createStyles({
        mainGrid: {
            display: 'flex'
        },
        layout: {
            width: '80%',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
                marginLeft: 'auto',
                marginRight: 'auto',
            },
            flexWrap: 'nowrap',
        },
        form: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            margin: 6,
            width: '100%',
        },
        fieldGrid: {
            padding: '6px',
        },
        buttonsGrid: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
        }
    }));

const OperadorDialog = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {handleSubmit, control} = useForm();

    const onSubmit = handleSubmit(async data => {
        const operador = {
            id: Number(data.id),
            nome: data.nome,
            abreviatura: data.abreviatura,
            alertaAposXHoras: data.alertaAposXHoras ? Number(data.alertaAposXHoras) : null,
        };
        await dispatch(postOperador(operador));
        props.cbDialog(false);
    });

    const handleClose = () => {
        props.cbDialog(false);
    };

    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Paper className={classes.layout}>
                    <Grid item container className={classes.mainGrid}>
                        <Grid item className={classes.fieldGrid} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant="h6" gutterBottom>
                                Novo Operador
                            </Typography>
                        </Grid>
                        <form className={classes.form}>
                            <Grid item className={classes.fieldGrid} sm={6} md={4} lg={3} xl={3}>
                                <TextFieldController control={control} fullWidth={true} name="id" label="ID" />
                            </Grid>
                            <Grid item className={classes.fieldGrid} sm={6} md={8} lg={9} xl={9}>
                                <TextFieldController control={control} fullWidth={true} name="nome" label="Nome" />
                            </Grid>
                            <Grid item className={classes.fieldGrid} sm={6} md={4} lg={4} xl={4}>
                                <TextFieldController control={control} fullWidth={true} name="abreviatura" label="Abreviatura" />
                            </Grid>
                            <Grid item className={classes.fieldGrid} sm={6} md={4} lg={4} xl={4}>
                                <TextFieldController control={control} fullWidth={true} name="alertaAposXHoras" label="Alerta Após X Horas" />
                            </Grid>

                            <Grid item className={classes.buttonsGrid} sm={12} md={12} lg={12} xl={12}>
                                <Button color="primary" onClick={onSubmit}>Salvar</Button>
                                <Button onClick={handleClose}>Fechar</Button>
                            </Grid>
                        </form>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    )
}

export default OperadorDialog;
